import Cookie from "js-cookie";
import {ARCHIVE_VERSIONS} from "@/shared/constants/archive";

export function baseUrlByArchiveModeVersion() {
    if(
        (process.env.VUE_APP_ARCHIVE_V1_API_URL || process.env.VUE_APP_ARCHIVE_0526_API_URL)
        && (process.env.VUE_APP_NAME === "dev"
            || process.env.VUE_APP_NAME === "staging"
            || process.env.VUE_APP_NAME === "production"
            || process.env.VUE_APP_NAME === "office")
    ) {
        return getArchiveModeDetailsByVersion(Cookie.get('archive_version')).url;
    }

    return process.env.VUE_APP_API_URL;
}

export function getArchiveModeDetailsByVersion(version) {
    let isVersionExist = ARCHIVE_VERSIONS.hasOwnProperty(version)
    if(isVersionExist) {
        return ARCHIVE_VERSIONS[version]
    }
    return ARCHIVE_VERSIONS.DEFAULT
}